export default {
  translation: {
    nav: {
      home: 'Nyumbani',
      trips: 'Safari',
      aboutUs: 'Kuhusu Sisi',
      uganda: 'Uganda',
      alerts: 'Arifa',
      wishlist: 'Mapenzi',
      language: 'Lugha',
      profile: 'Wasifu',
      settings: 'Mipangilio',
      signIn: 'Ingia',
      signUp: 'Jisajili',
      mainMenu: 'Menyu Kuu',
      account: 'Akaunti',
      blog: 'Blogu',
      adventures: 'Ujasiri'
    },
    adventures: {
      all: 'Ujasiri Wote',
      safariPackages: 'Vifurushi vya Safari',
      cityTours: 'Ziara za Miji',
      culturalTours: 'Ziara za Kitamaduni',
      selfDrive: 'Kujiendesha',
      allExperiences: 'Uzoefu Wote',
      gorillaTrekking: 'Kutembea na Gorilla',
      chimpanzeeTracking: 'Kufuatilia Sokwe Mtu',
      customizeSafari: 'Rekebisha Safari Yako',
      nightlifeGuide: 'Mwongozo wa Maisha ya Usiku'
    },
    hero: {
      title: 'Gundua Uganda',
      subtitle: 'na zaidi',
      description: 'Gundua Lulu ya Afrika na viongozi wenyeji wataalamu. Uzoefu usiosahaulika unakungoja katika mandhari ya kupendeza na utamaduni hai wa Uganda.',
      searchPlaceholder: 'Unakwenda wapi?',
      categories: {
        all: 'Zote',
        wildlife: 'Wanyamapori',
        safari: 'Safari',
        cultural: 'Utamaduni',
        adventure: 'Ujasiri',
        birding: 'Kutazama Ndege'
      },
      stats: {
        experiences: 'Uzoefu',
        guides: 'Viongozi wa Ndani',
        travelers: 'Wasafiri Walioridhika',
        rating: 'Wastani wa Ukadiriaji'
      }
    },
    experiences: {
      title: 'Uzoefu Bora Uganda',
      subtitle: 'Kuhifadhi uzoefu huu maarufu mapema kunakuhakikishia nafasi',
      categories: {
        all: 'Zote',
        wildlife: 'Wanyamapori',
        safari: 'Safari',
        cultural: 'Utamaduni',
        adventure: 'Ujasiri',
        birding: 'Kutazama Ndege'
      },
      viewDetails: 'Angalia Maelezo'
    },
    cityTours: {
      title: 'Ziara za Miji',
      subtitle: 'Gundua miji hai ya Uganda na vivutio vyake vya kipekee'
    },
    giveaway: {
      title: 'Shinda Safari ya Bure Nchini Uganda!',
      subtitle: 'Ofa ya Muda Mfupi',
      description: 'Tunawapa wasafiri 19 wenye bahati nafasi ya kipekee ya kupata uzoefu wa uchawi wa Uganda BURE!',
      enterButton: 'Nina Bahati',
      whatsIncluded: 'Kilichojumuishwa:',
      howItWorks: 'Jinsi Inavyofanya Kazi:',
      eligibility: 'Ustahiki:',
      viewTerms: 'Tazama masharti kamili',
      winners: 'washindi watachaguliwa',
      nextWinner: 'Tangazo la Mshindi Lijalo Katika:',
      days: 'Siku',
      hours: 'Saa',
      minutes: 'Dakika',
      seconds: 'Sekunde',
      enterGiveaway: 'Jiunge na Zawadi',
      yourEmail: 'Barua pepe Yako',
      enterEmail: 'Ingiza barua pepe yako kushinda',
      entryReceived: 'Uingizaji Umepokelewa!',
      thankYou: 'Asante kwa kuingia kwenye zawadi yetu! Angalia barua pepe yako kwa uthibitisho na subiri tangazo la mshindi.',
      pastWinners: 'Uzoefu wa Washindi Waliopita'
    },
    becomeGuide: {
      title: 'Kuwa Kiongozi wa TravelCord',
      subtitle: 'Shiriki Uzuri wa Uganda!',
      description: 'Geuza shauku yako ya Uganda kuwa kazi yenye thawabu. Jiunge na jumuiya yetu ya viongozi wenyeji wataalamu.',
      benefits: {
        earnings: 'Pata Zaidi',
        earningsDesc: 'Weka hadi 85% ya ada za uhifadhi',
        reach: 'Ufikio wa Kimataifa',
        reachDesc: 'Unganisha na wasafiri kutoka duniani kote',
        share: 'Shiriki Vito',
        shareDesc: 'Onyesha uzoefu wa ndani',
        flexible: 'Rahisi',
        flexibleDesc: 'Fanya kazi kwa ratiba yako'
      },
      stats: {
        guides: 'Viongozi Hai',
        travelers: 'Wasafiri Walioridhika',
        rating: 'Wastani wa Ukadiriaji',
        commission: 'Kiwango cha Kamisheni'
      },
      features: {
        profile: 'Wasifu wa kitaaluma na mfumo wa kuhifadhi',
        payments: 'Mchakato salama wa malipo',
        marketing: 'Msaada wa masoko na promosheni',
        support: 'Msaada wa wateja 24/7'
      },
      applyNow: 'Omba Sasa'
    },
    howItWorks: {
      title: 'Kwa Nini Kuhifadhi na TravelCord',
      subtitle: 'Kuunganisha wasafiri na uzoefu halisi na viongozi wa ndani nchini Uganda',
      features: {
        verifiedGuides: {
          title: 'Viongozi Wenyeji Waliothibitishwa',
          description: 'Viongozi wetu wote wanachunguzwa kwa makini na kuthibitishwa ili kuhakikisha unapata uzoefu bora.'
        },
        bestPrice: {
          title: 'Dhamana ya Bei Bora',
          description: 'Pata bei bora? Tutailingana na kukupa 10% ya ziada kwenye uhifadhi wako ujao.'
        },
        flexibleBooking: {
          title: 'Kufuta Rahisi',
          description: 'Ghairi bila malipo hadi masaa 24 kabla ya uzoefu wako.'
        },
        localExpertise: {
          title: 'Utaalamu wa Ndani',
          description: 'Pata maoni halisi na vito vilivyofichwa kutoka kwa viongozi wanaojua Uganda vizuri zaidi.'
        }
      },
      bookingProcess: {
        title: 'Mchakato Rahisi wa Kuhifadhi',
        steps: {
          browse: 'Vinjari uzoefu na uchague tarehe unayopendelea',
          choose: 'Chagua ukubwa wa kikundi chako na mahitaji yoyote maalum',
          secure: 'Hakikisha uhifadhi wako na mfumo wetu rahisi wa malipo'
        }
      },
      qualityAssurance: {
        title: 'Uhakikisho wa Ubora',
        licensed: 'Viongozi wenye leseni na bima',
        quality: 'Ukaguzi wa mara kwa mara wa ubora',
        groups: 'Vikundi vidogo kwa uzoefu bora'
      },
      support: {
        title: 'Msaada kwa Wateja',
        assistance: 'Msaada kwa wateja 24/7',
        payment: 'Ulinzi wa malipo salama',
        satisfaction: 'Kuridhika kunakohakikishwa'
      }
    },
    footer: {
      explore: {
        title: 'Chunguza',
        description: 'Anza safari ya kipekee kupitia nyika ya Uganda, ambapo gorilla wa milimani hutembea katika misitu ya kale, simba hupanda miti katika savanna kubwa, na tamaduni hai zinakukaribisha kwa mikono wazi.',
        findGuides: 'Tafuta Viongozi',
        safariAdventures: 'Safari za Ujasiri',
        culturalExperiences: 'Uzoefu wa Kitamaduni',
        wildlifeTours: 'Ziara za Wanyamapori',
        cityExplorations: 'Utafutaji wa Miji'
      },
      about: {
        title: 'Kuhusu',
        aboutUs: 'Kuhusu Sisi',
        becomeGuide: 'Kuwa Kiongozi',
        partnership: 'Ushirikiano',
        careers: 'Kazi',
        press: 'Kituo cha Habari'
      },
      contact: {
        title: 'Wasiliana',
        address: 'Ntinda, Kampala, Uganda',
        phone: '+256766830194',
        email: 'info@travelcord.guide'
      },
      legal: {
        copyright: '© 2025 TravelCord. Haki zote zimehifadhiwa.',
        privacy: 'Sera ya Faragha',
        terms: 'Masharti ya Huduma',
        cookies: 'Sera ya Vidakuzi',
        sitemap: 'Ramani ya Tovuti'
      }
    },
    common: {
      loading: 'Inapakia...',
      error: 'Hitilafu imetokea',
      retry: 'Jaribu tena',
      viewMore: 'Ona zaidi',
      viewLess: 'Ona kidogo',
      search: 'Tafuta',
      select: 'Chagua',
      cancel: 'Ghairi',
      submit: 'Wasilisha',
      save: 'Hifadhi',
      edit: 'Hariri',
      delete: 'Futa',
      confirm: 'Thibitisha',
      back: 'Rudi',
      next: 'Ifuatayo',
      finish: 'Maliza',
      close: 'Funga',
      required: 'Inahitajika',
      optional: 'Hiari',
      from: 'kuanzia',
      reviews: 'maoni',
      book: 'Hifadhi',
      seeAll: 'Ona yote',
      for: 'kwa',
      years: 'miaka'
    },
    forms: {
      booking: {
        title: 'Hifadhi Uzoefu Huu',
        personalInfo: 'Taarifa Binafsi',
        tourDetails: 'Maelezo ya Ziara',
        payment: 'Maelezo ya Malipo',
        firstName: 'Jina la Kwanza',
        lastName: 'Jina la Familia',
        email: 'Barua Pepe',
        phone: 'Namba ya Simu',
        date: 'Tarehe',
        travelers: 'Wasafiri',
        specialRequests: 'Maombi Maalum',
        total: 'Jumla',
        submit: 'Kamilisha Uhifadhi'
      },
      quote: {
        title: 'Omba Nukuu',
        name: 'Jina',
        email: 'Barua Pepe',
        phone: 'Simu',
        message: 'Ujumbe',
        submit: 'Tuma Ombi'
      }
    },
    success: {
      title: 'Uwasilishaji Umefaulu!',
      message: 'Asante kwa uwasilishaji wako. Tumepokea ombi lako na tutawasiliana nawe hivi karibuni.',
      returnHome: 'Rudi Nyumbani'
    },
    pages: {
      aboutUs: {
        title: 'Kuhusu Sisi',
        subtitle: 'Kuunganisha Wasafiri na Utaalamu wa Ndani',
        description: 'Gundua hadithi yetu, dhamira yetu, na timu yetu iliyojitolea.',
        ourStory: 'Hadithi Yetu',
        ourValues: 'Maadili Yetu',
        contactUs: 'Wasiliana Nasi'
      },
      allExperiences: {
        title: 'Uzoefu Wote Uganda',
        subtitle: 'Gundua mkusanyiko wetu kamili wa uzoefu halisi wa Uganda',
        filters: 'Vichujio',
        sortBy: 'Panga kwa',
        noResults: 'Hakuna uzoefu uliopatikana',
        resetFilters: 'Weka upya vichujio'
      },
      blog: {
        title: 'Blogu ya Safari na Usafiri Uganda',
        subtitle: 'Miongozo ya wataalamu, vidokezo na hadithi kuhusu kutembea na gorilla, safari na uzoefu wa kitamaduni',
        searchPlaceholder: 'Tafuta miongozo ya safari, kutembea na gorilla...',
        featuredStories: 'Hadithi Zilizoangaziwa',
        categories: 'Jamii',
        popularTopics: 'Mada Maarufu',
        newsletterTitle: 'Sasisho za Safari',
        writeForUs: 'Tuandikie'
      },
      careers: {
        title: 'Jiunge na Timu Yetu',
        subtitle: 'Tusaidie kuonyesha uzuri wa Uganda kwa ulimwengu',
        benefits: 'Faida',
        openPositions: 'Nafasi Zilizopo',
        applicationForm: 'Fomu ya Maombi'
      },
      cityTours: {
        title: 'Ziara za Miji Uganda',
        subtitle: 'Gundua miji hai ya Uganda na viongozi wetu wa ndani',
        kampala: 'Ziara za Kampala',
        jinja: 'Ziara za Jinja',
        entebbe: 'Ziara za Entebbe',
        bookNow: 'Hifadhi Sasa'
      },
      customizeAdventure: {
        title: 'Rekebisha Ujasiri Wako',
        subtitle: 'Unda uzoefu wako kamili wa Uganda',
        chooseGuide: 'Chagua Kiongozi Wako',
        customizeExperience: 'Rekebisha Uzoefu Wako',
        finalDetails: 'Maelezo ya Mwisho',
        requestQuote: 'Omba Nukuu'
      },
      gorillaTrekking: {
        title: 'Kutembea na Gorilla Uganda',
        subtitle: 'Kutana na gorilla wa milimani katika makazi yao ya asili',
        essentialInfo: 'Taarifa Muhimu',
        bestTime: 'Wakati Bora',
        requirements: 'Mahitaji',
        whatToBring: 'Nini cha Kuleta'
      },
      guideProfile: {
        title: 'Wasifu wa Kiongozi',
        experience: 'Uzoefu',
        languages: 'Lugha',
        specialties: 'Utaalamu',
        reviews: 'Maoni',
        tours: 'Ziara Zilizokamilika',
        bookNow: 'Hifadhi Sasa',
        contactGuide: 'Wasiliana na Kiongozi',
        aboutGuide: 'Kuhusu Kiongozi',
        certifications: 'Vyeti',
        achievements: 'Mafanikio'
      },
      nightlife: {
        title: 'Mwongozo wa Maisha ya Usiku Uganda',
        subtitle: 'Mwongozo wako kamili wa kuchunguza mandhari ya maisha ya usiku ya Uganda',
        packages: 'Vifurushi Vyote Vimejumuishwa',
        clubs: 'Vilabu na Baa',
        streetFood: 'Mzunguko wa Chakula cha Mtaani',
        safety: 'Usalama na Adabu',
        bookNow: 'Hifadhi Sasa',
        essentials: 'Vitu Muhimu vya Maisha ya Usiku',
        bestNights: 'Usiku Bora',
        peakHours: 'Saa za Kilele',
        startingPoint: 'Mahali pa Kuanzia',
        dressCode: 'Kanuni za Mavazi',
        whatsIncluded: 'Kilichojumuishwa katika Kifurushi Chako',
        vipEntry: 'Kuingia VIP Kwenye Klabu',
        vipEntryDesc: 'Ruka foleni na upatikanaji wa VIP kwa klabu na maeneo yote. Hakuna malipo ya kuingia - yote yamejumuishwa!',
        foodDrinks: 'Chakula & Vinywaji',
        foodDrinksDesc: 'Furahia chakula cha mtaani na vinywaji vya kukaribisha katika kila eneo. Chaguzi za vinywaji za ziada zinapatikana.',
        safetyGuidance: 'Usalama & Mwongozo',
        safetyGuidanceDesc: 'Viongozi wataalamu na wafanyakazi wa usalama wanahakikisha usalama wako usiku kucha wakati wanakuonyesha maeneo bora.',
        whyBookWithUs: 'Kwa Nini Kuhifadhi Nasi',
        photoPackage: 'Kifurushi cha Picha cha Ziada',
        photoPackageDesc: 'Piga picha za usiku wako na kifurushi chetu cha upigaji picha wa kitaalamu. Mpiga picha aliyejitolea atajiunga na kikundi chako kudokeza uzoefu wako.',
        groupBooking: 'Faida za Uhifadhi wa Kikundi',
        groupBookingDesc: 'Unahifadhi kama kikundi? Furahia faida maalum na punguzo wakati unapohifadhi kwa watu 4 au zaidi!',
        contactGroup: 'Wasiliana kwa Uhifadhi wa Kikundi',
        contactGroupDesc: 'Kwa vikundi vya watu 4 au zaidi, wasiliana na timu yetu kwa mipango maalum na punguzo.',
        streetFoodCircuit: 'Mzunguko wa Chakula cha Mtaani',
        nightMarkets: 'Masoko ya Usiku & Bazari',
        nightclubScene: 'Mandhari ya Klabu za Usiku',
        tierSystem: 'Mfumo Maarufu wa Ngazi 3 wa Uganda',
        platinumTier: 'Klabu za Ngazi ya Platinamu',
        goldTier: 'Klabu za Ngazi ya Dhahabu',
        undergroundScene: 'Mandhari ya Chini ya Ardhi',
        safetyEtiquette: 'Usalama & Adabu',
        safetyPriority: 'Usalama Wako ni Kipaumbele Chetu',
        clubEntryTips: 'Vidokezo vya Kuingia Klabu',
        transport: 'Usafiri',
        proTips: 'Vidokezo vya Kitaalamu kutoka kwa Viongozi Wetu',
        weeklyHighlights: 'Mambo Muhimu ya Kila Wiki',
        faq: 'Maswali Yanayoulizwa Mara kwa Mara',
        readyToExperience: 'Uko Tayari Kupata Uzoefu wa Maisha ya Usiku ya Uganda?',
        readyToExperienceDesc: 'Hifadhi kifurushi chako cha maisha ya usiku kinachojumuisha yote leo na tuache tushughulikie kila kitu wakati unapofurahia usiku usiosahaulika!',
        viewPackages: 'Tazama Vifurushi',
        contactUs: 'Wasiliana Nasi',
        lastUpdated: 'Ilisasishwa mwisho',
        contributor: 'Mchangiaji',
        reportChanges: 'Ripoti mabadiliko'
      },
      partnership: {
        title: 'Ushirikiano na TravelCord',
        subtitle: 'Jiunge na jukwaa kuu la utalii la Uganda',
        opportunities: 'Fursa za Ushirikiano',
        benefits: 'Faida',
        application: 'Maombi ya Ushirikiano',
        testimonials: 'Ushuhuda'
      },
      resources: {
        title: 'Rasilimali za Usafiri Uganda',
        subtitle: 'Miongozo inayoweza kupakuliwa, ramani, na orodha za ukaguzi',
        categories: 'Jamii za Rasilimali',
        download: 'Pakua Mwongozo wa Bure',
        testimonials: 'Wasafiri Wanasema Nini'
      },
      safariPackages: {
        title: 'Vifurushi vya Safari',
        subtitle: 'Gundua vifurushi vyetu vya safari vilivyochaguliwa kwa uangalifu',
        filters: 'Vichujio',
        priceRange: 'Kiwango cha Bei',
        duration: 'Muda',
        viewDetails: 'Angalia Maelezo',
        bookNow: 'Hifadhi Sasa'
      },
      selfDriveSafaris: {
        title: 'Safari za Kujiendesha Uganda',
        subtitle: 'Chunguza Uganda kwa kasi yako mwenyewe',
        chooseVehicle: 'Chagua Gari Lako',
        customizeExperience: 'Rekebisha Uzoefu Wako',
        requirements: 'Mahitaji',
        roadConditions: 'Hali za Barabara',
        safetyGuidelines: 'Miongozo ya Usalama'
      },
      travelGuides: {
        title: 'Viongozi Wataalamu wa Ndani Uganda',
        subtitle: 'Unganisha na viongozi wetu wenye uzoefu wa ndani',
        filters: 'Vichujio',
        sortBy: 'Panga kwa',
        specialties: 'Utaalamu',
        languages: 'Lugha',
        viewProfile: 'Angalia Wasifu'
      },
      uganda: {
        title: 'Karibu Uganda',
        subtitle: 'Gundua Lulu ya Afrika',
        nationalParks: 'Hifadhi za Taifa',
        popularActivities: 'Shughuli Maarufu',
        bestTimeToVisit: 'Wakati Bora wa Kutembelea',
        travelTips: 'Vidokezo vya Usafiri'
      },
      writeForUs: {
        title: 'Tuandikie',
        subtitle: 'Shiriki uzoefu wako wa usafiri Uganda',
        guidelines: 'Miongozo ya Uwasilishaji',
        whatWeLookFor: 'Tunachotafuta',
        requirements: 'Mahitaji ya Makala',
        benefits: 'Faida',
        submitPitch: 'Wasilisha Wazo'
      }
    }
  }
};